import { Pagination } from "@/types/pagination";

export const extractPagination = (response: any): Pagination => {
  return {
    total: response.total,
    page: response.page,
    pageSize: response.pageSize,
    totalPages: response.totalPages,
  };
};
